export default "__VITE_ASSET__d5288b97__"